import ActionTypes from './actionTypes';

export const setChart = chart => dispatch => dispatch({ type: ActionTypes.SET_CHART, chart });

export const nextChart = chart => dispatch => dispatch({ type: ActionTypes.NEXT_CHART, chart });

export const pastChart = chart => dispatch => dispatch({ type: ActionTypes.PAST_CHART, chart });
